import type { Locale } from '@change-corgi/config/locales';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { ImpactStory } from './getTopImpactStories';
import { getTopImpactStories } from './getTopImpactStories';
import type { HomepageV3ConfigQuery, HomepageV3ConfigQueryVariables } from './getV3Data.graphql';
import { HomepageV3Config } from './getV3Data.graphql';

type Props = {
	locale: string;
	utilityContext: UtilityContext;
};

type Tips = ReadonlyArray<{
	title: string;
	guideLink: string;
}>;

export type V3Data = {
	topImpactStories: ImpactStory[];
	tips: Tips;
};

export async function getV3Data({ locale, utilityContext }: Props): Promise<V3Data> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<HomepageV3ConfigQuery, HomepageV3ConfigQueryVariables>({
		query: HomepageV3Config,
		rejectOnError: false,
	});

	const localeConfig = data?.featureConfigs.capybaraHomepageV3?.perLocaleConfig?.[locale as Locale];

	if (!localeConfig) return { topImpactStories: [], tips: [] };

	return {
		topImpactStories: await getTopImpactStories({
			topImpactStoriesConfig: localeConfig.topImpactStories,
			utilityContext,
		}),
		tips: localeConfig.tips,
	};
}
